module.exports = __webpack_public_path__ + "img/img-flow-3-1.bcde5b91.png";